import React from 'react';

import Button, { BUTTON_TYPES, BUTTON_SIZES } from 'buyside/components/presentation/Button/button';

import {
  ViewerIntroRequest,
  useUpdateViewerIntroRequestMutation
} from 'interfaces/graphql-typings';
const { viewerIntroRequestStatuses } = require('buyside/util/constantsFromRails.json');

const ViewerIntroRequestActionsPending: React.FC<{ id: string; currentUserId: string }> = ({
  id,
  currentUserId
}) => {
  const [updateViewerIntroRequest] = useUpdateViewerIntroRequestMutation({
    update: (cache, { data }) => {
      cache.modify({
        id: cache.identify({
          id: currentUserId,
          __typename: 'User'
        }),
        fields: {
          viewerIntroRequests: (cachedRequests, { readField }) => {
            cachedRequests.edges.filter(
              (node: ViewerIntroRequest) =>
                data?.updateViewerIntroRequest?.viewerIntroRequest?.id !== readField('id', node)
            );
          }
        }
      });
    }
  });

  return (
    <>
      <Button
        onClick={(): void => {
          updateViewerIntroRequest({
            variables: { id, status: viewerIntroRequestStatuses.accepted }
          });
        }}
        text="Accept"
        size={BUTTON_SIZES.TINY}
        type={BUTTON_TYPES.MAJOR}
      />
      <Button
        onClick={(): void => {
          updateViewerIntroRequest({
            variables: { id, status: viewerIntroRequestStatuses.hidden }
          });
        }}
        text="Reject"
        size={BUTTON_SIZES.TINY}
        type={BUTTON_TYPES.DANGER}
      />
    </>
  );
};

export default ViewerIntroRequestActionsPending;
